var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"modalGroupEdit",attrs:{"size":"xl","title":_vm.modalTitle,"hideFooter":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('group-edit-form',{ref:"groupForm",on:{"onClickSave":function($event){return _vm.processGroupSaved()},"onClickExit":_vm.hideModal}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }